import { fetchJson } from '../utils/http';
import { fetchDiscoveryURLs } from '../domains/discovery/fetchDiscoveryURLs';

export async function saveCollectedData(prospectId, taxId, externalId, startedAt) {
  const body = {
    'applicant-id': prospectId,
    'tax-id': taxId,
    'credolab-id': externalId,
    'started-at': startedAt,
    'finished-at': new Date().toISOString(),
  };

  const discoveryURLs = await fetchDiscoveryURLs();

  // eslint-disable-next-line camelcase
  if (!discoveryURLs?.save_collected_data) {
    throw new Error('Discovery fetch response unexpected - missing endpoint');
  }

  await fetchJson(discoveryURLs.save_collected_data, {
    method: 'POST',
    body,
  });
}

